import { render, staticRenderFns } from "./CouponsStepForm.vue?vue&type=template&id=4a05718a&scoped=true&"
import script from "./CouponsStepForm.vue?vue&type=script&lang=js&"
export * from "./CouponsStepForm.vue?vue&type=script&lang=js&"
import style0 from "./CouponsStepForm.vue?vue&type=style&index=0&id=4a05718a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a05718a",
  null
  
)

export default component.exports